import { render, staticRenderFns } from "./CmsProtectedClientsTable.vue?vue&type=template&id=0212b1a2&scoped=true"
import script from "./CmsProtectedClientsTable.vue?vue&type=script&lang=ts"
export * from "./CmsProtectedClientsTable.vue?vue&type=script&lang=ts"
import style0 from "./CmsProtectedClientsTable.vue?vue&type=style&index=0&id=0212b1a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0212b1a2",
  null
  
)

export default component.exports